angular.module('bribac.components.ibacEditor', [
  'bribac.translations',
  'bribac.values',
  'bribac.entities.kinds',
  'bribac.services.api',
  'bribac.components.ibacEventEditor',
  'bribac.entities.ibacEventEditorFactory'
])

  .component('ibacEditor', {
    templateUrl: 'ibac-editor-component.html',
    controller: 'IbacEditorComponentCtrl',
    bindings: {
      form: '<',
      ibac: '<',
      add: '<'
    }
  })

  .controller('IbacEditorComponentCtrl', function(
    $window,
    $translate,
    MAC_ADDRESS_REGEX,
    KINDS,
    api,
    permissions,
    ibacEventEditorFactory
  ) {
    var $ctrl = this

    $ctrl.MAC_ADDRESS_REGEX = MAC_ADDRESS_REGEX
    $ctrl.permissions = permissions

    // Init.

    $ctrl.$onInit = function() {
      $ctrl.eventFormIsOpen = false
    }

    $ctrl.openAddNewEventForm = function() {
      $ctrl.eventOpenForEditing = ibacEventEditorFactory({
        // Set ID so it works with ng-repeat.
        id: 'TEMPORARY_' + Math.random(),
      })
      $ctrl.eventFormIsOpen = true
    }

    $ctrl.onAddNewEventSuccess = function(newIbacEvent) {
      var event =  $ctrl.ibac.activationEvents.filter(function(ae) {
        return ae.id === newIbacEvent.id
      })[0]
      if (event) {
        event.date = newIbacEvent.date
        event.activate = newIbacEvent.activate
      } else {
        $ctrl.ibac.activationEvents.push(newIbacEvent)
      }
      resetAddEventForm()
    }

    $ctrl.removeEvent = function(eventToRemove) {
      var answer = $window.confirm($translate.instant('views.editIbac.deleteEventQuestion', null, "", "", ""))
      if (answer) {
        $ctrl.ibac.activationEvents = $ctrl.ibac.activationEvents.filter(function(event) {
          return event.id !== eventToRemove.id
        })
      }
    }

    $ctrl.editEvent = function(event) {
      $ctrl.eventOpenForEditing = event
      $ctrl.eventFormIsOpen = true
    }

    function resetAddEventForm() {
      $ctrl.eventFormIsOpen = false
      $ctrl.newIbacEvent = null
    }

    $ctrl.onAddNewEventCancel = resetAddEventForm
  })
